import React from 'react';
import Button from '../../components/Button';
import { Link } from 'react-router-dom';
import { LuMoveRight } from 'react-icons/lu';
import frame from '../../assets/frame.png';
import isomo from '../../assets/isomo.png';
import opportunities_uwc from '../../assets/opportunities_uwc.png';
import opportunities_ala from '../../assets/opportunities_ala.png';
import opportunities_cornerstone from '../../assets/opportunities_cornerstone.png';
import opportunities_rca from '../../assets/opportunities_rca.png';

import opportunities_mastercard from '../../assets/opportunities_mastercard.png';
import meto from '../../assets/meto.png';
import yyas from '../../assets/yyas.png';
import Partners from '../partners/Partners';
import Footer from '../../components/Footer';

const dummyOpportunities = [
  {
    id: 1,
    title: 'Mētō Platform',
    description:
      'Mētō is a powerful platform that connects African students to top universities worldwide. It helps you explore scholarships, prepare your application, and receive mentorship from experts who guide you through every step of your academic journey.',
    date: 'Oct 17, 2025',
    image: meto,
  },
  {
    id: 2,
    title: 'Yale Young African Scholars (YYAS)',
    description:
      'YYAS is an academic and leadership program for secondary school students in Africa, organized by Yale University. The program helps students strengthen their university applications, improve academic skills, and connect with peers across the continent.',
    date: 'Oct 17, 2025',
    image: yyas,
  },
  {
    id: 3,
    title: 'United World College',
    description:
      'UWC (United World Colleges) is a global network of 18+ schools and colleges that offer selected students a chance to study the International Baccalaureate (IB) in inspiring international communities. This is one of the most competitive and respected opportunities out there for high school students.',
    date: 'June 19,2025',
    image: opportunities_uwc,
  },

  {
    id: 4,
    image: opportunities_ala,
    date: 'June 19,2025',
    title: 'ALA African Leadership Academy (South Africa)',
    description:
      'ALA is more than a school — it\u2019s a launchpad for Africa\u2019s future leaders. Based in South Africa, it brings together outstanding young people from across the continent for a two-year program focused on leadership, entrepreneurship, and academics.',
  },
  {
    id: 5,
    image: opportunities_cornerstone,
    date: 'June 19,2025',
    title: 'Cornerstone Leadership Academy (CLA)',
    description:
      'Cornerstone Leadership Academy is a highly respected residential high school program designed to develop young servant leaders of strong character, purpose, and vision. The academy places a strong emphasis on leadership, ethics, and spiritual growth, alongside academic excellence.',
  },

  {
    id: 6,
    image: opportunities_rca,
    date: 'June 19,2025',
    title: 'Rwanda Coding Academy (RCA)',
    description:
      'Rwanda Coding Academy is a government-backed, elite technical school offering a three-year advanced secondary education focused on software engineering, embedded systems, and cybersecurity.',
  },

  {
    id: 7,
    image: opportunities_mastercard,
    date: 'Feb 16, 2024',
    title: 'Mastercard Foundation Scholars Program',
    description:
      'The Mastercard Foundation Scholars Program offers full scholarships to bright young Africans who aspire to make a difference. Beyond financial support, it provides mentorship, leadership training, and career guidance to help you succeed.',
  },
  {
    id: 8,
    title: 'Isomo Academy 2024',
    description:
      'Applications open from mid December each year until late late April before the beginning of term 3 each academic year. For more details and application go to Bridge2 Rwanda or use the following link ',
    date: 'Feb 21,2024',
    image: isomo,
  },
];
const AllOpportunities = ({ setChosenOpportunity, setNavigateToSection }) => {
  return (
    <div className="w-full">
      <div className="w-full flex flex-col px-6 md:px-12 py-6 lg:px-32 lg:py-12">
        <div
          className="bg-cover bg-center flex flex-col lg:flex-row items-center justify-between font-rubik max-h-[250px] lg:h-[150px] w-full px-12 py-6 rounded-2xl"
          style={{ backgroundImage: `url(${frame})` }}
        >
          <div className="flex flex-col gap-1">
            <h1 className="text-secondary font-bold text-2xl lg:text-4xl font-quicksand">
              Opportunities
            </h1>
          </div>

          <p className=" w-full text-center lg:text-start lg:w-[40%]  text-white font-rubik text-base lg:text-lg">
            Welcome to our Opportunities page: <br /> Explore a wide range of
            programs, scholarships, competitions, and more designed just for
            you.
          </p>
        </div>

        <h1 className="text-2xl font-quicksand text-primary font-bold my-6">
          Recent Opportunities
        </h1>

        <div className="w-full flex flex-col lg:flex-row lg:flex-wrap gap-4">
          {dummyOpportunities.map((opportunity) => {
            return (
              <div className="bg-grey rounded-2xl gap-4 flex items-start w-full lg:w-[48%] p-4">
                <div className="max-w-[200px] h-[120px] bg-cover rounded-2xl overflow-hidden">
                  <img
                    src={opportunity.image}
                    alt=""
                    className="w-full h-full bg-cover"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  {/* <p className="text-fontGrey text-sm">{opportunity.date}</p> */}
                  <p className="font-quicksand font-bold text-2xl">
                    {opportunity.title.length > 30
                      ? opportunity.title.slice(0, 30) + '...'
                      : opportunity.title}
                  </p>

                  <p className="font-rubik text-fontGrey">
                    {opportunity.description.length > 80
                      ? opportunity.description.slice(0, 80) + '...'
                      : opportunity.description}
                  </p>

                  <Link to={'/opportunities/single'} className="w-fit">
                    <div
                      className="flex gap-2 items-center w-fit cursor-pointer"
                      onClick={() => {
                        setChosenOpportunity(opportunity.id);
                      }}
                    >
                      <p className="text-secondary font-rubik">Read more</p>
                      <LuMoveRight size={20} color="#FDB935" />
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Partners />
      <Footer setNavigateToSection={setNavigateToSection} />
    </div>
  );
};

export default AllOpportunities;
